import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HitmakerRoutingModule } from './hitmaker-routing.module';
import { HitmakerMoviePageComponent } from './component/hitmaker-movie-page/hitmaker-movie-page.component';
import { HitmakerMainPageComponent } from './component/hitmaker-main-page/hitmaker-main-page.component';
import { CastingComponent } from './component/casting/casting.component';
import { PreProductionComponent } from './component/pre-production/pre-production.component';
import { FilmingComponent } from './component/filming/filming.component';
import { PostProductionComponent } from './component/post-production/post-production.component';
import { ReleaseComponent } from './component/release/release.component';
import { StageUploadComponent } from './component/stage-upload/stage-upload.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { StageUpdateComponent } from './component/stage-update/stage-update.component';
import { MixpanelModule } from 'src/app/shared/mix-pane.modul';
import { HitmakerNewMainPageComponent } from './component/hitmaker-new-main-page/hitmaker-new-main-page.component';
import { CastingUpdateComponent } from './component/casting-update/casting-update.component';


@NgModule({
  declarations: [
    HitmakerMainPageComponent,
    HitmakerMoviePageComponent,
    CastingComponent,
    PreProductionComponent,
    FilmingComponent,
    PostProductionComponent,
    ReleaseComponent,
    StageUploadComponent,
    StageUpdateComponent,
    HitmakerNewMainPageComponent,
    CastingUpdateComponent
  ],
  imports: [
    CommonModule,
    HitmakerRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatCardModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MixpanelModule
  ]
})
export class HitmakerModule { }
